

<script lang="ts">
  import type { OrganizationFrame } from "@kontextwerk/control-web-client"
  import type { PermissionState } from "@kontextwerk/control-web-frame/shared/logic/authorization"
  import type { OrgaViewFrameContext as NotificationsFrameContext } from "../../context"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import type { PageContext } from "./navigation"

  import type { OrgaViewFrameContext } from "../../context"
  import InboxTab from "./tabs/inbox"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: OrgaViewFrameContext
    activeTab: string
  }>()

  const pageContext = $derived.by<PageContext>(() => ({
    permissions: viewFrameContext.permissions,
    organization: viewFrameContext.organization,
    onNotificationsChanged: viewFrameContext.onNotificationsChanged,
  }))

  const canViewNotifications = $derived(pageContext.permissions.allows("core.notifications", "view"))
</script>

{#if canViewNotifications}
  <InboxTab {viewFrameContext} {pageContext} />
{/if}
